<template>
  <div
    class="app-page flex flex-col h-full"
    data-test="developers-main-page"
  >
    <service-navigation-header
      :service-translations="serviceTranslations"
      :token="token"
      :config="config"
      :account-id="accountId"
      :user-role="userRole"
    >
      <template #account>
        <auth-popover
          :token="token"
          :dark-mode-options="{
            attribute: 'data-theme',
            valueDark: 'dark',
          }"
        />
      </template>
    </service-navigation-header>
    <div
      class="page-content bg-surface-1 dark:bg-surface-1-dark grow overflow-auto"
      data-test="page-content"
    >
      <router-view />
    </div>
  </div>
</template>
<script setup lang="ts">
import { AuthPopover } from '@onereach/auth-ui-module';
import { ServiceNavigationHeader } from '@onereach/service-navigation';
import { onBeforeMount } from 'vue';
import pkg from '../../package.json';
import useDocsStore from '@/stores/Docs.store';

defineProps<{
  token?: string | null;
  config: Record<string, unknown>;
  accountId?: string | null;
  userRole?: string | null;
}>();

const serviceTranslations = pkg.projectConfig.translations;
const { getDocsAction } = useDocsStore();

onBeforeMount(() => {
  getDocsAction();
});
</script>
